import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import * as dayjs from 'dayjs';
import { environment } from 'src/environments/environment';
import { CheckinForm } from '../models/checkin-form.model';
import { ProfileModel } from '../models/profile.model';
import { VisitModel } from '../models/visit.model';
import { AccommodationService } from './accommodation.service';
import { AuthService } from './auth.service';
import { DataService } from './data.service';
import { GetTranslationService } from './get-translation.service';
import { ToastMachineService } from './toast-machine.service';

@Injectable({
  providedIn: 'root'
})
export class CheckinService {

  constructor(
    private authServ: AuthService,
    private toaster: ToastMachineService,
    private translator: GetTranslationService,
    private visitServ: AccommodationService,
    private dataServ: DataService
  ) { }

  async checkIn(forms: FormGroup[]) {
    this.authServ.control();
    forms.forEach(async (form, index) => {
      const VAL = form.value as CheckinForm;
      const PROFILE = new ProfileModel();

      PROFILE.guest_status = 'Online Check In';

      PROFILE.first_name = VAL.name;
      PROFILE.last_name = VAL.surname;
      PROFILE.entry_date = dayjs(new Date(VAL.checkin)).set('hour', 3).set('minute', 0)
        .set('second', 0).set('millisecond', 0).toISOString();
      PROFILE.release_date = dayjs(new Date(VAL.checkout)).set('hour', 3).set('minute', 0)
        .set('second', 0).set('millisecond', 0).toISOString();
      PROFILE.e_mail = VAL.email;
      PROFILE.date_of_birth = dayjs(new Date(VAL.birthdate)).set('hour', 3).set('minute', 0)
        .set('second', 0).set('millisecond', 0).toISOString();
      PROFILE.phone_no = VAL.phone;
      PROFILE.id_no = VAL.idno;
      PROFILE.hotel_id = environment.hotelId || +localStorage.getItem('hotelId') || this.dataServ.rData.id;
      PROFILE.vehicle_no = VAL.vehicleno;
      PROFILE.address = VAL.address;
      PROFILE.city = VAL.city;
      PROFILE.country = VAL.country;
      PROFILE.gender = VAL.gender;
      PROFILE.allergy = VAL.allergies;
      PROFILE.allergy_description = VAL.alleryDesc;
      PROFILE.signature = VAL.signature;
      PROFILE.passport_front_image_url = VAL.passportFront;
      PROFILE.passport_back_image_url = VAL.passportBack;
      PROFILE.invoice_info = VAL.invoiceInf;

      if (VAL.invoiceInf) {
        PROFILE.company_name = VAL.companyName;
        PROFILE.company_address = VAL.companyAddress;
        PROFILE.staff_name = VAL.staffName;
        PROFILE.invoice_id_no = VAL.idNo;
        PROFILE.tax_area = VAL.taxArea;
        PROFILE.tax_no = VAL.taxNo;
        PROFILE.invoice_mail = VAL.companyEmail;
      }

      if (this.authServ.isLogged && index === 0) {

        if (!this.authServ.profile) {
          await this.authServ.getMe();
        }

        PROFILE.id = this.authServ.profile.id;
        await this.authServ.putMe(PROFILE);

        const VISIT = new VisitModel(PROFILE);

        VISIT.start_date = PROFILE.entry_date;
        VISIT.end_date = PROFILE.release_date;
        VISIT.room_no = PROFILE.room_no;
        VISIT.profile_id = PROFILE.id;
        VISIT.night = dayjs(VISIT.end_date).diff(VISIT.start_date, 'day');

        await this.visitServ.postVisit(VISIT);

      } else {
        await this.authServ.checkIn(PROFILE);
      }
    });

    const MSG = await this.translator.getTranslate('Welcome to our hotel. Enjoy!');
    this.toaster.toastMachine(MSG, 'primary', 3000);

  }

}
